import React, {useState} from 'react'
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { setIsLoggedIn } from '../../features/account/account.slice';

const VerifyUserWithPassword = ({openModal, closeModal, setProceed, setServerMessage, setModalHistory}) => {
  const [currentPassword, setCurrentPassword] = useState(""); // State to hold the current password
  const [showCurrentPassword, setShowCurrentPassword] = useState(false); // State to toggle password visibility
  const [processing, setProcessing] = useState(false); // State to indicate processing status

  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const dispatch = useDispatch();

  const validatePassword = (password) => {
    // No need for regex, just check that the length is at least 8. Allowing them to mess up the rest of the password is fine. It's part of the process to confirm their identity.
    return password.length >= 8;
  };

  const verifyPassword = async (password) => {

    // Validate the password format
    if (!validatePassword(password)) {
        setServerMessage({ success: false, message: "Password must be at least 8 characters long." });
        return;
    }

    try{
        const response = await fetch(`${apiUrl}/user/verify-password`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ password }),
        });

        if (response.status === 401) {
          // Unauthorized, possibly session expired
          dispatch(setIsLoggedIn(false)); // Redux update will clear user data and redirect to login
          return;
        };
    
        const data = await response.json();
    
        if (data.success) {
          // Password verification successful
          setProceed(true);
          //remove the last modal from the history
          setModalHistory((prevHistory) => prevHistory.slice(0, -1));
          setServerMessage(data);
        } else {
          // Password verification failed
          setServerMessage(data);
        }
    } catch (error) {
        console.error("Error verifying password:", error);
        setServerMessage({ success: false, message: "An error occurred while verifying the password." });
    }
  }

  const onSubmit = async () => {
    setProcessing(true);
    if(currentPassword === "") {
        setServerMessage({ success: false, message: "Please enter your current password." });
        setProcessing(false);
        return;
    }

    //API call to verify the password
    await verifyPassword(currentPassword)
    setProcessing(false);
  }

  return (
    <div className='d-flex flex-column justify-content-between' style={{height: "100%"}}>
        <h4>Confirm Identity</h4>
        <p className='m-0 mb-3'>
            Please verify your identity by entering your password before proceeding. 
            This step is important for your security.
        </p>
        <div style={{ position: "relative" }}>
            <input
                className="custom-input rounded"
                type={showCurrentPassword ? "text" : "password"}
                placeholder="Current password"
                onChange={(e) => setCurrentPassword(e.target.value)} // Update state with the current password
                onFocus={(e) => (e.target.style.borderColor = "#FFCC19")} // Change border color on focus
                onBlur={(e) => (e.target.style.borderColor = "#3C3E4C")} // Reset border color on blur
                style={{
                    height: "45px",
                    backgroundColor: "#171A29",
                    width: "100%", // Ensure the input takes the full width of the container
                    paddingRight: "40px", // Add padding to make space for the icon
                    border: "1px solid #3C3E4C",
                    color: "white",
                }}
            />
            <FontAwesomeIcon
                icon={showCurrentPassword ? faEyeSlash : faEye} // Toggle between eye and eye-slash icons
                onClick={() => setShowCurrentPassword(!showCurrentPassword)} // Toggle password visibility
                style={{
                    position: "absolute",
                    right: "10px", // Position the icon 10px from the right edge of the input
                    top: "50%", // Center the icon vertically
                    transform: "translateY(-50%)", // Adjust for vertical centering
                    cursor: "pointer",
                    color: "#AEAFBA",
                    width: "20px",
                    height: "20px",
                }}
            />
        </div>
        <div className='d-flex justify-content-center align-items-center mt-4'>
        <button 
          className='rounded w-100' style={{ backgroundColor: '#FFCC19', height: "45px", fontWeight: 600, border: "none", color: "black" }}
          onClick={onSubmit}
          disabled={processing}
        >
          Continue
        </button>
      </div>
    </div>
  )
}

export default VerifyUserWithPassword